import "ant-design-vue/es/modal/style";
import _Modal from "ant-design-vue/es/modal";
import { defineComponent, onMounted, onUnmounted, ref, watch } from 'vue';
import UserExamHeader from './components/UserExamHeader.vue';
import UserExamBody from './components/UserExamBody.vue';
import { declareProviders, useService } from '@kaokei/use-vue-service';
import { CheatService } from '@/services/exam/cheat.service';
import { ExamService } from '@/services/exam/exam.service';
import { EnvCheckService } from '@/services/exam/envCheck.service';
import { CountdownService } from '@/services/exam/countdown.service';
import { QuestionService } from '@/services/exam/question.service';
import { PlayerManagerService } from '@/services/exam/playerManager.service';
import { RecordVideoService } from '@/services/recordVideo/recordVideo.service';
import { ScreenMediaService } from '@/services/recordVideo/media.service';
import { useRoute, useRouter } from 'vue-router';
import CheatMask from './components/CheatMask.vue';
import { UserService } from '@/services/user.service';
import { RetainService } from '@/services/retain.service';
import { MediaService } from '@/services/exam/media.service';
import { TOKEN_INVALID_ERRCODE } from '@/utils';
import RecordScreen from './recordScreen/index.vue';
export default defineComponent({
  name: 'Examination',
  components: {
    UserExamHeader: UserExamHeader,
    UserExamBody: UserExamBody,
    CheatMask: CheatMask,
    RecordScreen: RecordScreen
  },
  setup: function () {
    var _a;
    declareProviders([CountdownService, QuestionService, ExamService, CheatService, EnvCheckService, PlayerManagerService, MediaService, RecordVideoService, ScreenMediaService]);
    var route = useRoute();
    var router = useRouter();
    var userService = useService(UserService);
    var examService = useService(ExamService);
    var retainService = useService(RetainService);
    var recordVideoService = useService(RecordVideoService);
    var screenMediaService = useService(ScreenMediaService);
    var questionService = useService(QuestionService);
    var loading = ref(true);
    var hideCheatMask = route.query.hideMask;
    examService.setUserExamId(+route.params.id);
    retainService.initData({
      userExamId: +route.params.id
    });
    if (route.params.answerId) {
      // 设置为查看答案模式
      // 禁止修改功能
      examService.setAnswerPaperId(+route.params.answerId);
      if ((_a = route.query) === null || _a === void 0 ? void 0 : _a.areaId) {
        examService.setReviewAreaId(+route.query.areaId);
      }
      examService.setAnswerMode(true);
    }
    var goBack = function () {
      var _a;
      var qsPlatform = route.query.platform;
      var platform = Array.isArray(qsPlatform) ? qsPlatform[0] : qsPlatform || '';
      var contestMainListPath = platform ? (_a = route.meta.contestListPath) === null || _a === void 0 ? void 0 : _a[platform] : undefined;
      if (contestMainListPath) {
        retainService.dispose();
        window.location.replace(contestMainListPath);
        return;
      }
      router.replace({
        name: 'Home'
      });
    };
    var ideEventListener = function (event) {
      var eventData = event === null || event === void 0 ? void 0 : event.data;
      if (eventData) {
        if (eventData.eventType === 'networkError') {
          if (eventData.networkInfo && eventData.networkInfo.data) {
            if (eventData.networkInfo.data.errCode === TOKEN_INVALID_ERRCODE) {
              userService.logout();
            }
          }
        }
      }
    };
    var warnModal;
    watch(function () {
      return userService.user;
    }, function (user) {
      if (!(user && user.userId)) {
        warnModal = _Modal.warn({
          title: '提醒',
          content: '考试账号被异常登录，请勿向他人透露考试账号和密码，可能影响考试成绩',
          okText: '重新登录',
          onOk: goBack
        });
      } else {
        warnModal === null || warnModal === void 0 ? void 0 : warnModal.destroy();
      }
    });
    // 获取试卷信息
    var routeSuffix = String(route.params.suffix);
    examService.startExam({
      source: routeSuffix.startsWith('recorder') ? 1 : undefined
    }).then(function () {
      var _a;
      if (!examService.destroyed) {
        if (!examService.answerMode) {
          window.addEventListener('message', ideEventListener, false);
        }
      }
      loading.value = false;
      screenMediaService.setExamId(((_a = examService === null || examService === void 0 ? void 0 : examService.exam) === null || _a === void 0 ? void 0 : _a.examId) || -1);
    }).catch(function (e) {
      var _a;
      // add sentry mark
      // console.log('setTag','api', 'startExam');
      var newQuery = ((_a = route.meta) === null || _a === void 0 ? void 0 : _a.ignoreQuery) ? undefined : route.query;
      router.push({
        name: 'UserItemList',
        query: newQuery
      });
    });
    var showLeaveConfirmation = function (next) {
      _Modal.confirm({
        title: '返回提示',
        content: '确认离开么？请再次检查内容是否保存',
        // icon: createVNode(ExclamationCircleOutlined),
        okText: '确认',
        cancelText: '取消',
        zIndex: 900000,
        onOk: function () {
          next();
        },
        onCancel: function () {
          next(false);
        }
      });
    };
    var lastHistoryState = history.state;
    var removeBeforeEach;
    onMounted(function () {
      if (!route.params.answerId) {
        retainService.initEvent();
        // 路由守卫返回的取消函数
        removeBeforeEach = router.beforeEach(function (to, from, next) {
          var isBack = history.state && history.state.position < lastHistoryState.position;
          if (from.name === 'Examination' && to.name !== 'Examination') {
            if (isBack) {
              showLeaveConfirmation(next);
            } else {
              lastHistoryState = history.state;
              next();
            }
          } else {
            next();
          }
        });
      }
      // 这里获取考试按钮的规则
      if (recordVideoService.isRecorderPage) {
        examService.getRecordButtonRule();
      }
    });
    onUnmounted(function () {
      // 清除副作用
      examService.destroy();
      _Modal.destroyAll();
      window.removeEventListener('message', ideEventListener, false);
      retainService.dispose();
      // 如果存在路由守卫返回的取消函数 就执行取消逻辑
      if (removeBeforeEach) {
        removeBeforeEach();
      }
    });
    // 同步变更数据
    watch(function () {
      return examService.introductionVideoConfig;
    }, function (config) {
      if (config === null || config === void 0 ? void 0 : config.maxSeconds) {
        screenMediaService.videoPreviewConfig.recordMaxTime = config.maxSeconds;
      }
    });
    return {
      loading: loading,
      examService: examService,
      hideCheatMask: hideCheatMask,
      recordVideoService: recordVideoService,
      questionService: questionService
    };
  }
});